export default "__VITE_ASSET__DPHMlG5$__"